import {
  Text,
  Button,
  makeStyles,
} from "@fluentui/react-components";
import {
  SignOut24Regular,
  ArrowLeft16Regular,
} from "@fluentui/react-icons";

const useStyles = makeStyles({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 12px",
    height: "44px",
    background: "linear-gradient(135deg, #6366F1, #8B5CF6)",
    color: "#fff",
    flexShrink: 0,
  },
  left: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    minWidth: 0,
  },
  logo: {
    width: "22px",
    height: "22px",
    borderRadius: "5px",
    backgroundColor: "rgba(255,255,255,0.2)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
    fontWeight: 800,
    flexShrink: 0,
  },
  divider: {
    width: "1px",
    height: "16px",
    backgroundColor: "rgba(255,255,255,0.25)",
    flexShrink: 0,
  },
  viewTitle: {
    color: "rgba(255,255,255,0.9)",
    fontWeight: 600,
  },
  right: {
    display: "flex",
    alignItems: "center",
    gap: "2px",
    flexShrink: 0,
  },
});

interface HeaderProps {
  companyName: string;
  viewTitle: string;
  onLogout: () => void;
  onBack?: () => void;
}

export function Header({ companyName, viewTitle, onLogout, onBack }: HeaderProps) {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <div className={styles.left}>
        {onBack && (
          <Button
            appearance="transparent"
            icon={<ArrowLeft16Regular />}
            onClick={onBack}
            size="small"
            style={{ color: "#fff", minWidth: 0, padding: "2px" }}
            title="Back to home"
          />
        )}
        <div className={styles.logo}>B</div>
        <Text style={{ color: "#fff", fontWeight: 700 }} size={200}>
          {companyName}
        </Text>
        <div className={styles.divider} />
        <Text className={styles.viewTitle} size={200}>
          {viewTitle}
        </Text>
      </div>
      <div className={styles.right}>
        <Button
          appearance="transparent"
          icon={<SignOut24Regular />}
          onClick={onLogout}
          size="small"
          style={{ color: "rgba(255,255,255,0.8)" }}
          title="Sign out"
        />
      </div>
    </div>
  );
}
